/**
 * Professional Circular Layout Worklet
 * 
 * Mathematically positions children in a circular, orbital, or radial 
 * pattern around a center point. Perfect for menus, dashboards, or data viz.
 */

class CircularLayout {
  async layout(children: any[], edges: any, constraints: any, styleMap: any) {
    const inlineSize = constraints.fixedInlineSize;
    const blockSize = constraints.fixedBlockSize || inlineSize;
    
    const centerX = inlineSize / 2;
    const centerY = blockSize / 2;
    const radius = parseFloat(styleMap.get('--fluent-circular-radius')) || Math.min(centerX, centerY) * 0.8;
    const startAngle = parseFloat(styleMap.get('--fluent-circular-start-angle')) || 0;
    
    const childFragments: any[] = [];
    const angleStep = (2 * Math.PI) / children.length;

    for (let i = 0; i < children.length; i++) {
        const angle = startAngle + i * angleStep;
        
        const fragment = await children[i].layoutNextFragment({});
        
        // Position center of child on the circle
        fragment.inlineOffset = centerX + Math.cos(angle) * radius - fragment.inlineSize / 2;
        fragment.blockOffset = centerY + Math.sin(angle) * radius - fragment.blockSize / 2;
        
        childFragments.push(fragment);
    }

    return {
        childFragments
    };
  }
}

registerLayout('fluent-circular', CircularLayout);
